"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_regexps_1 = require("@uip-alpha/utils-regexps");
var inputtingMobile = utils_regexps_1.regexps.inputtingMobile, chnMobile = utils_regexps_1.regexps.chnMobile, hkmoMobile = utils_regexps_1.regexps.hkmoMobile, twMobile = utils_regexps_1.regexps.twMobile, chnLandline = utils_regexps_1.regexps.chnLandline, chnLandlineNew = utils_regexps_1.regexps.chnLandlineNew, hkmoLandline = utils_regexps_1.regexps.hkmoLandline, twLandline = utils_regexps_1.regexps.twLandline, chnLandlineShare = utils_regexps_1.regexps.chnLandlineShare, mail = utils_regexps_1.regexps.mail;
var TEL = {
    /**
     * 手机号码的输入规则
     * @param  {[type]}   phone [手机号]
     * @return {Boolean}        [boolean]
     */
    isInputtingMobile: function (phone) {
        // 符合手机号码的输入规则，当前输入的为11位以及11位以内的数字（中间可能包含空格）
        var patter = new RegExp(inputtingMobile);
        return patter.test(phone);
    },
    /**
     * 大陆手机校验
     * @param  {[type]}   phone [手机号]
     * @return {Boolean}        [boolean]
     */
    CHNMobile: function (phone) {
        // 大陆手机，加国际区号
        var patter = new RegExp(chnMobile);
        return patter.test(phone);
    },
    /**
     * 香港澳门手机校验
     * @param  {[type]}   phone [手机号]
     * @return {Boolean}        [boolean]
     */
    HKMOMobile: function (phone) {
        // 香港手机，5，6，8，9开头的8位数字 澳门手机，澳门手机于2006年9月在手机号码前加6，6开头的8位数
        var patter = new RegExp(hkmoMobile);
        return patter.test(phone);
    },
    /**
     * 台湾手机校验
     * @param  {[type]}   phone [手机号]
     * @return {Boolean}        [boolean]
     */
    TWMobile: function (phone) {
        // 台湾手机，09开头的10位数，由于大陆拨打台湾手机时要去掉第一个0，故也允许是以9开头的任意9位数
        var patter = new RegExp(twMobile);
        return patter.test(phone);
    },
    /**
     * 大陆固话400校验
     * @param  {[type]}   tel [座机号]
     * @return {Boolean}      [boolean]
     */
    CHNLandlineShare: function (tel) {
        // 大陆固话校验
        var patter = new RegExp(chnLandlineShare);
        return patter.test(tel);
    },
    /**
     * 大陆固话校验
     * @param  {[type]}   tel [座机号]
     * @return {Boolean}      [boolean]
     */
    CHNLandline: function (tel) {
        // 大陆固话
        var patter = new RegExp(chnLandline);
        return patter.test(tel);
    },
    CHNLandlineNew: function (tel) {
        // 大陆固话 - 区号可不填
        var patter = new RegExp(chnLandlineNew);
        return patter.test(tel);
    },
    /**
     * 香港澳门固话校验
     * @param  {[type]}   tel [座机号]
     * @return {Boolean}      [boolean]
     */
    HKMOLandline: function (tel) {
        //  香港固话 2或3开头的8位数 澳门固话  28开头的8位数
        var patter = new RegExp(hkmoLandline);
        return patter.test(tel);
    },
    /**
     * 台湾固话校验
     * @param  {[type]}   tel [座机号]
     * @return {Boolean}      [boolean]
     */
    TWLandline: function (tel) {
        //  台湾的固话, 0开头的区号，由于大陆拨打台湾手机时要去掉第一个0，故0不写也可以，2至4位数，号码为7-8位
        var patter = new RegExp(twLandline);
        return patter.test(tel);
    },
    /**
     * 邮箱校验
     * @param  {[type]}   mailStr [输入邮箱]
     * @return {Boolean}          [Boolean]
     */
    isMail: function (mailStr) {
        mailStr = mailStr.trim();
        var mailReg = new RegExp(mail);
        return mailReg.test(mailStr);
    }
};
exports.default = {
    name: 'utils-check-tel',
    install: function (UIP) {
        UIP.checkModule('utils', 'check', 'TEL');
        UIP.utils.check.TEL = TEL;
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/utils-check-tel/dist/index.js
// module id = 29Nm
// module chunks = 1